import { __decorate } from "tslib";
import { css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { sharedStyles } from '../../common/css/shared-styles';
import { USBrandCampaign } from '../../common/us-branding';
//import scrollama from "scrollama";
let CampaignSectionPowerPartnership = class CampaignSectionPowerPartnership extends USBrandCampaign {
    render() {
        return html `
    <div class="component">
    <div class="inner">
    <h2>Ridefiniamo la partnership</h2>
    <p class="subtitle">Siamo al tuo fianco per aiutarti a restare sempre al passo con i tempi, offrendoti risorse e ispirazioni utili per raggiungere il successo. Ecco alcune delle risrse che mettiamo a tua disposizione:</p>
<div class="grid">
  <div class="left-col">
    <div class="card">
      <!-- check this -->
        <h4>Approfondimenti di mercato</h4>
        <p>Leggi le analisi dei nostri team di investimento sugli eventi di mercato più recenti.</p>
        <a href="https://www.franklintempleton.it/articoli" data-card-title="Approfondimenti di mercato" @click="${this.trackCallout}">Scopri di più</a>
    </div>
  </div>
  <div class="mid-col">
  <div class="card">
        <h4>FT Institute</h4>
        <p>La nostra missione è offrire soluzioni di ricerca mirate, in grado di rispondere con efficacia alle esigenze e alle sfide dei nostri clienti. Per farlo, esploriamo e analizziamo in profondità ogni contesto, valorizzando al massimo le risorse e le competenze interne. La nostra struttura, organizzata per aree di ricerca specializzate, ci consente di sviluppare conoscenze approfondite e trasformarle in applicazioni pratiche e concrete.</p>
        <a href="https://www.franklintempleton.it/approfondimenti/franklin-templeton-institute/index" data-card-title="FT Institute" @click="${this.trackCallout}">Accedi ora</a>
    </div>
  </div>  
  <div class="right-col">
  <div class="card">
        <h4>FT Academy</h4>
        <p>La nostra missione è fornire ai clienti approfondimenti, formazione e consulenza per raggiungere risultati straordinari. Offriamo programmi di consulenza e formazione personalizzati per arricchire il vostro curriculum formativo.</p>
        <a href="https://www.franklintempleton.it/approfondimenti/ft-academy" data-card-title="Franklin Templeton Academy" @click="${this.trackCallout}">Scopri i nostri programmi</a>
    </div>
  </div>
</div>
  </div>
  </div>
        <slot></slot>`;
    }
};
CampaignSectionPowerPartnership.styles = [
    sharedStyles,
    css `
    :host {
        display: block;
        width: 100%;
        background: #001E62;
        padding: 0;
        position: relative;
        z-index: 4;
        margin: 0;
        padding-top: 4rem;
        padding-bottom: 4rem;
    }

    .card {
      margin-bottom: 2rem;
      padding: 2rem;
    }

    .inner {
      /*padding: 0 2rem 2rem 2rem;      */
    }

    .component {
      margin: 0 2rem;
    }

    @media(min-width: 768px) {

      .inner {
        padding: 0;
      }

      :host {
        display: flex;        
        margin: 0 auto;        
        padding: 6rem 0 7rem 0;
        /*min-height: 100vh;*/
        align-content: center;
        flex-wrap: wrap;             
      }

      .grid {  
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-template-rows: 1fr;
        gap: 3rem;
        grid-auto-flow: row;
      }
  
      .card, .left-col, .mid-col, .right-col {
        height: 100%;
        margin-bottom: 0;
      }

      .card {
        padding: 2rem 2rem 0 2rem;        
      }
      
      .left-col {
        justify-self: start;
        align-self: start;
        grid-area: 1 / 1 / 2 / 2;
        width: 100%;
      }
      
      .mid-col {
          justify-self: end;
          align-self: start;        
          grid-area: 1 / 2 / 2 / 3;
          width: 100%;
        }
  
      .right-col {
        justify-self: end;
        align-self: start;
        grid-area: 1 / 3 / 2 / 4;
        width: 100%;
      }
    }

    @media(min-width: 1200px) {
      :host {     
        padding: 6rem 0 10rem 0;
      }      

      .component {
        max-width: 1200px;
        margin: 0 auto;
      }
    }

    h2, p {
        color: var(--white);
      }

    .card {
      background: #fff;
      border-radius: 12px;

      & p {
        color: var(--ft-black);
      }

      & h4 {
        color: rgba(0,30,98,1);
        font-family: var(--font-bold);   
        letter-spacing: -0.4px;   
      }
    }

    img {
      max-width: 200px;
    }

    a {
      /*
      display: inline-block;
      background: var(--ft-sky-blue);
      padding: 0.6rem 1.25rem;
      border-radius: 45px;
      text-decoration: none;
      color: #fff;      
      */
      color: var(--ft-sky-blue);
    }    

    .subtitle {
      margin: 2rem 0 3rem 0;
    }



    p, a {
      font-size: 1.1rem;
    }    

  `
];
CampaignSectionPowerPartnership = __decorate([
    customElement('campaign-section-power-partnership')
], CampaignSectionPowerPartnership);
export { CampaignSectionPowerPartnership };
//# sourceMappingURL=campaign-section-power-partnership.js.map